import { BaseModel } from './base-model';
import { Servicio } from './servicio';
import { Usuario } from './usuario';
import { InternetPlanZona } from './internet-plan-zona';
import { ClientNetworkNode } from './client-network-node';

export class ServicioCliente extends BaseModel {
  servicioId?: number | null;
  usuarioId?: number | null;
  fechaInicio?: string;
  fechaFin?: string;
  codigoUbigeo?: string;
  direccion?: string;
  referenciasDomicilio?: string;
  latitud?: string;
  longitud?: string;
  linkCoordenadas?: string;
  detalles?: string;
  registrador?: number;
  responsables?: string;
  tipoServicio?: string | null;
  tipoPago?: string | null;
  estado?: string;
  servicio?: Servicio | null;
  usuario?: Usuario;
  servicioClienteInternet?: ServicioClienteInternet[];
  nodoCliente?: ClientNetworkNode;

  constructor(object?: any) {
    super(object);
    if (object) {
      if (object.servicio) {
        this.servicio = new Servicio(object.servicio);
      }
      if (object.usuario) {
        this.usuario = new Usuario(object.usuario);
      }
      if (object.servicioClienteInternet) {
        this.servicioClienteInternet = object.servicioClienteInternet.map((data: ServicioClienteInternet) => {
          const obj = new ServicioClienteInternet(data);
          obj.nombreServicioInternet = this.servicio ? this.servicio.nombre : '';
          return obj;
        });
      }
    }
  }

  initializeValues(): void {
    this.servicioId = null;
    this.usuarioId = null;
    this.fechaInicio = '';
    this.fechaFin = '';
    this.codigoUbigeo = '';
    this.direccion = '';
    this.referenciasDomicilio = '';
    this.longitud = '';
    this.latitud = '';
    this.linkCoordenadas = '';
    this.detalles = '';
    this.registrador = 1;
    this.responsables = '';
    this.tipoServicio = '';
    this.tipoPago = '';
    this.estado = '';
  }
}

export class ServicioClienteInternet extends BaseModel {
  servicioClienteId?: number | null;
  internetPlanZonaId?: number | null;
  velocidadSubida?: number | null;
  velocidadBajada?: number | null;
  precioMensual?: number | null;
  fechaInicioPlan?: string | null;
  fechaFinPlan?: string | null;
  motivoCambioPlan?: string;
  estado?: string;
  empresaId?: number | null;
  servicioCliente?: ServicioCliente;
  internetPlanZona?: InternetPlanZona;
  private _nombreServicioInternet?: string | null;

  constructor(object?: any) {
    super(object);
    if (object) {
      if (object.servicioCliente) {
        this.servicioCliente = new ServicioCliente(object.servicioCliente);
      }
    }
  }

  initializeValues(): void {
    this.servicioClienteId = null;
    this.internetPlanZonaId = null;
    this.velocidadSubida = null;
    this.velocidadBajada = null;
    this.precioMensual = null;
    this.fechaInicioPlan = '';
    this.fechaFinPlan = '';
    this.motivoCambioPlan = '';
    this.estado = '';
    this.empresaId = null;
  }

  set nombreServicioInternet(nombreServicio: string | null | undefined) {
    const descripcionInternetPlanZona = this.internetPlanZona ? this.internetPlanZona.descripcion : '';
    if (this.internetPlanZonaId) {
      this._nombreServicioInternet = nombreServicio + ' - ' + descripcionInternetPlanZona;
    } else {
      if (this.velocidadBajada) {
        this._nombreServicioInternet = nombreServicio + ' - ' + this.velocidadBajada + 'Mbps';
      } else {
        this._nombreServicioInternet = nombreServicio;
      }
    }
  }

  get nombreServicioInternet() {
    return this._nombreServicioInternet;
  }
}
